export default __webpack_public_path__ + "static/media/video3.70916afa.png";